import React from 'react'
import './loader.css'

const Loader = () => (
   <svg className='stroke__svg' width='150' height='150' viewBox='0 0 100 100'>
      <polyline className='line-cornered stroke-still' points='0,0 100,0 100,100' strokeWidth='10'
                fill='none'></polyline>
      <polyline className='line-cornered stroke-still' points='0,0 0,100 100,100' strokeWidth='10'
                fill='none'></polyline>
      <polyline className='line-cornered stroke-animation' points='0,0 100,0 100,100' strokeWidth='10'
                fill='none'></polyline>
      <polyline className='line-cornered stroke-animation' points='0,0 0,100 100,100' strokeWidth='10'
                fill='none'></polyline>
   </svg>
)
export default Loader